/**
 * Grupos temáticos (nichos) — cada um tem landing própria e SÓ WhatsApp.
 *
 * Separados de SITE_CONFIG de propósito: os links de lá (grupo principal +
 * Telegram) são HARD-FROZEN no CLAUDE.md. Estes são novos e não herdam o freeze.
 *
 * `slug` e `label` alimentam o evento Lead (ver LeadGroup em facebookPixel.ts):
 * o pixel é o mesmo do site ("Macaco Ofertas"), só o content_name/destination
 * mudam para separar o lead do nicho do lead do grupo principal.
 */
import type { LeadGroup } from "@/lib/facebookPixel";

export interface GrupoTematico extends LeadGroup {
  whatsappUrl: string;
}

export const GRUPO_CAMPING: GrupoTematico = {
  slug: "camping",
  label: "Camping",
  whatsappUrl: "https://chat.whatsapp.com/EKDHExXFnHj9sflieJgMKd",
};
